import { useEffect } from 'react';
import { useAPI } from '@/services';
import { UseQueryOptions } from 'react-query';
import { useFundEfficiencyCompareContext } from '../../contexts/fundEfficiencyCompareContext';

export const useGetMarketCapComparison = (
  reactQueryOptions?: UseQueryOptions<any>
) => {
  const { selectedParallelMarket, setParallelMarketTitleFa } =
    useFundEfficiencyCompareContext();

  const { data, ...rest } = useAPI(['fund', 'getMarketCapComparison'], {
    input: {},
    reactQueryOptions: {
      ...reactQueryOptions,
    },
  });

  // * Set symbol title in context store, if it wasn't already set
  useEffect(() => {
    if (!selectedParallelMarket.titleFa) {
      const foundedSymbol = data?.items[0].symbols.find((item) => {
        return item.symbolName === selectedParallelMarket.symbolName;
      });
      const titleFa = foundedSymbol?.titleFa;

      if (titleFa) {
        setParallelMarketTitleFa(titleFa);
      }
    }
  }, [data?.items]);

  return { data, ...rest };
};
